import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-311755d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-3" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "d-block d-md-none title" }, " 참여 TIP ", -1))
const _hoisted_5 = { class: "box-row" }
const _hoisted_6 = { class: "box-button" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "d-none d-md-block title" }, " 참여 TIP ", -1))
const _hoisted_8 = {
  href: "https://zep.us/play/yBVRWw",
  target: "_blank"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("p", null, "‘캡틴쓱 시즌2’ 메타버스 세상에 접속하여"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("캡틴쓱과 함께 분리배출 게임을 클리어하면,"),
    /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
    /*#__PURE__*/_createElementVNode("strong", null, "당첨 확률 UP!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "tip d-none d-md-block" }, " - 자세한 내용은 SSG.COM의 캠페인 페이지를 확인해주세요 - ")
], -1))

import ImageGood from '../images/page-3/good.png';
import Button from '../components/button.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(ImageGood),
        class: "image"
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("a", _hoisted_8, [
            _createVNode(Button, {
              text: "쓱본부 바로가기",
              shadow: ""
            })
          ])
        ]),
        _hoisted_9
      ])
    ])
  ]))
}
}

})